import styled, { keyframes } from 'styled-components';

import THEME from '../../assets/styles/config';

const slide = keyframes`
  0% {
    left: -30%;
  }

  100% {
    left: 100%;
  }
`;

// Always this tall, so the line coming and going moves nothing.
export const Slot = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 19px;
`;

export const Line = styled.div`
  position: relative;
  width: 100%;
  height: 3px;
  overflow: hidden;
  border-radius: 2px;
  background: #e3eef5;
`;

export const Slider = styled.div`
  position: absolute;
  top: 0;
  width: 30%;
  height: 100%;
  border-radius: 2px;
  background: ${THEME.colors.primaryColor};
  animation: ${slide} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    left: 0;
    width: 100%;
    animation: none;
    opacity: 0.6;
  }
`;
